import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import EmployerPageFrame from "../../components/employer/EmployerPageFrame";
import { Button } from "../../components/ui/button";

export default function StbAdvTranslate() {
  const { adv_id } = useParams();
  const [translation, setTranslation] = useState("");
  const [loading, setLoading] = useState(false);

  const starteUebersetzung = async () => {
    setLoading(true);
    try {
      const res = await axios.post(`/api/gpt/translate-adv`, {
        adv_id,
        zielsprache: "en",
      });
      setTranslation(res.data.translation);
    } catch (err) {
      console.error("Fehler bei Uebersetzung:", err);
      alert("Fehler bei der GPT-Uebersetzung.");
    }
    setLoading(false);
  };

  useEffect(() => {
    starteUebersetzung();
  }, [adv_id]);

  return (
    <EmployerPageFrame
      title="Anzeige uebersetzen"
      subtitle="Bestehender GPT-Translate-Pfad ohne neue Fachlogik, aber jetzt als breiter Employer-Arbeitsraum mit konsistenter Tokenbasis."
      actions={(
        <Button className="dashboard-action-button" onClick={starteUebersetzung}>
          Neu uebersetzen
        </Button>
      )}
      contentClassName="space-y-4"
    >
      <section className="dashboard-card-shell space-y-3">
        <div>
          <span className="dashboard-kicker">GPT Translate</span>
          <h2 className="dashboard-card-title">Anzeige #{adv_id}</h2>
        </div>
        {loading ? (
          <p className="text-sm text-sky-700">GPT uebersetzt...</p>
        ) : (
          <pre className="whitespace-pre-wrap rounded-2xl border border-slate-200 bg-slate-50 p-4 text-sm text-slate-800">
            {translation || "Noch keine Uebersetzung vorhanden."}
          </pre>
        )}
      </section>
    </EmployerPageFrame>
  );
}
